export const getRDRReport = /* GraphQL */ `
  mutation generateEHRDataReport($requestBody: AWSJSON) {
    generateEHRDataReport(requestBody: $requestBody)
  }
`

export const getChartData = /* GraphQL */ `
  query getChartData($body: AWSJSON) {
    getChartData(body: $body)
  }
`


export const getEquipmentDetailsById = /* GrapghQL */ `
  query GetEquipmentBuildingInfo($equipmentId: ID!) {
    getEquipment(id: $equipmentId) {
      id
      parentId
      name
      uiType
      type
      modelName
      deviceId
      building {
      tz
      offeringCodes
      }
      device {
        serial
      }
    }
  }
`

